import getFetchOptions from 'utils/getFetchOptions';

import { PaginatedResponse, handlePaginatedResponse, handleResponse, toQueryString } from '../utils';
import { BlockedCardsQueryParams } from './blockedcards.types';

export const getBlockedCards = async (
  apiAprilBaseUri: string,
  queryParams: BlockedCardsQueryParams,
): Promise<PaginatedResponse<any>> => {
  let qParams = toQueryString(queryParams, [
    'customerId',
    'merchantId',
    'transactionId',
    'cardBlockId',
    'cardBrand',
    'eventType',
  ]);
  const options = await getFetchOptions('GET');

  return await fetch(`${apiAprilBaseUri}/sources/blockedcards${qParams}`, options).then(handlePaginatedResponse);
};

export const unblockCard = async (apiAprilBaseUri: string, cardBlockId: string): Promise<string> => {
  const payload = {
    RemoveBlockOnCard: {},
  };
  const options = await getFetchOptions('PATCH', JSON.stringify(payload));
  return await fetch(`${apiAprilBaseUri}/sources/blockedcards/${cardBlockId}`, options).then(handleResponse);
};
